/** Textos da suíte: lançador, conta, equipe, sem acesso (SPEC-v2 2; SPEC 9.11). */
import type { Role } from '@rota/contracts';

export const ROLE_NAME: Readonly<Record<Role, string>> = {
  owner: 'Dono',
  partner: 'Sócio',
  traffic: 'Gestor de tráfego',
  creative: 'Copy e edição',
  support: 'Suporte e social media',
  expert: 'Expert',
  tech: 'Técnico',
  tv: 'TV do escritório',
};

export const suitePageCopy = {
  brand: 'Rota',
  documentTitle: (page: string) => `${page} · Rota`,
  launcher: {
    page: 'Início',
    greeting: (period: 'manha' | 'tarde' | 'noite', name: string) =>
      `${period === 'manha' ? 'Bom dia' : period === 'tarde' ? 'Boa tarde' : 'Boa noite'}, ${name}`,
    subtitle: 'Escolha onde trabalhar agora.',
    hint: 'Atalhos: 1 a 4 abrem a área; Enter continua de onde você parou.',
    loading: 'Carregando o resumo das áreas',
  },
  account: {
    menu: 'Conta',
    trigger: (initials: string, name: string) => `${initials}, conta de ${name}`,
    profile: 'Conta',
    security: 'Segurança',
    team: 'Equipe',
    theme: 'Aparência',
    themes: { system: 'Automática', light: 'Clara', dark: 'Escura' },
    signOut: 'Sair',
    viewAs: 'Ver como',
  },
  palette: {
    label: 'Buscar ou executar um comando',
    placeholder: 'Buscar telas e comandos…',
    empty: 'Nada encontrado.',
    goTo: 'Ir para',
    areas: 'Áreas',
    goToArea: (name: string) => `Ir para a área ${name}`,
    account: 'Conta',
    search: 'Buscar',
    searchKeys: '⌘K',
  },
  noAccess: {
    title: 'Sem acesso',
    text: (area: string) => `Seu papel não abre a área ${area}.`,
    action: 'Ir para a minha tela inicial',
  },
  notFound: {
    title: 'Página não encontrada',
    text: 'O endereço não existe ou mudou de lugar.',
    action: 'Ir para a minha tela inicial',
  },
  placeholder: {
    badge: 'Em construção',
    text: 'Esta tela chega na próxima onda da V2. A rota, a navegação, os atalhos e as permissões já estão ligados.',
    widgets: 'Widgets previstos',
  },
  shell: {
    nav: 'Navegação principal',
    skip: 'Pular para o conteúdo',
    collapse: 'Recolher a barra lateral',
    expand: 'Mostrar a barra lateral',
    openNav: 'Abrir a navegação completa',
    closeNav: 'Fechar a navegação',
    more: 'Mais',
    areas: 'Áreas',
    launcher: 'Início da Rota',
  },
} as const;
